'use strict';

var debounce = require('lodash/debounce');
var endpoint = $('.suggestions-wrapper').data('url');
var minChars = 3;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).parents('#header-container').find('.suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('.site-search .reset-button').click();
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    if (!(typeof (response) === 'object')) {
        $suggestionsWrapper.append(response).show();
        $(this).siblings('.reset-button').addClass('d-sm-block');
        positionSuggestions(this);
        $('body').removeClass('search-suggestion-open').addClass('search-suggestion-open');
        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
            applyModals(this);
        } else {
            hoverCategory();
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
        $.spinner().stop();
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    if (direction === 1) {
        $('.suggestions__header div').first().focus();
    } else if (direction === -1) {
        $('.navbar-header').find('.nav-item a').last().focus();
    }
    // Below code is commented because there is no use of it as per current requirement, if things will not break this will be totally removed
    // var suggestionsList = $('.suggestions .item');
    // if (suggestionsList.filter('.selected').length === 0) {
    //     suggestionsList.first().addClass('selected');
    //     $('input.search-field').each(function () {
    //         $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
    //     });
    // } else {
    //     suggestionsList.each(function (index) {
    //         var idx = index + direction;
    //         if ($(this).hasClass('selected')) {
    //             $(this).removeClass('selected');
    //             $(this).removeAttr('aria-selected');
    //             if (suggestionsList.eq(idx).length !== 0) {
    //                 suggestionsList.eq(idx).addClass('selected');
    //                 suggestionsList.eq(idx).attr('aria-selected', true);
    //                 $(this).removeProp('aria-selected');
    //                 $('input.search-field').each(function () {
    //                     $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
    //                 });
    //             } else {
    //                 suggestionsList.first().addClass('selected');
    //                 suggestionsList.first().attr('aria-selected', true);
    //                 $('input.search-field').each(function () {
    //                     $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
    //                 });
    //             }
    //             return false;
    //         }
    //         return true;
    //     });
    // }
}

/**
 * Retrieves trending items and most popular
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getDefaultSuggestions(scope) {
    var endpoint = $('.suggestions-wrapper').data('url-default');
    $.when( $.ajax({
        context: scope,
        url: endpoint,
        method: 'GET',
        success: processResponse
    })).then(function() {
        if ($('.trending-items__slot').children().length > 0) {
            $('.trending-items__slot').removeClass('d-none');
        } else {
            $('.trending-items__default').removeClass('d-none');
        }
    });
}

/**
 * Retrieves category products
 * @return {JQuery} - .suggestions-wrapper element
 */
function getCategoryProducts(endpoint) {
    $.spinner().start();
    $.ajax({
        url: endpoint,
        method: 'GET',
        success: function (response) {
            var productsContainer = $('.suggestions__products');
            productsContainer.empty();
            productsContainer.append(response);
        }
    });
    $.spinner().stop();
}

function hoverCategory() {
    $('.suggestions__categories .item__name').on('mouseenter focus', debounce(function () {
        var endpoint = $(this).data('url');
        getCategoryProducts(endpoint);
    }, 300));
}

module.exports = function () {

    $(document).keyup(function(e) {
        if (e.key === "Escape") {
            $('.reset-button').trigger('click');
        }
    });

    // Main Header will Appear & Disappear on Scrolling Up & Down
    var prevScrollPos = $(window).scrollTop();
    var prevVisiblePos = prevScrollPos;
    var mainHeader = $('#header-container');
    var mainHeaderHeight = mainHeader.outerHeight(true);
    var embroiderySetCount;

    $(window).on('load', function() {
        embroiderySetCount= $('.edit-pesonalization-page .embroidery-sets .embroidery-set.completed');

        if ($('script.collection-page').length) {
            let collectionSchema = JSON.parse($('.collection-page').html());
            if (collectionSchema.itemListElement.length == 0) {
                let itemListElement = [];
                let productLinks = $('.product-tile .tile-body #yotpo-bottomline-top-div');

                productLinks.each(function (e) {
                    itemListElement.push({
                        '@type': 'ListItem',
                        position: Number(e) + 1,
                        url: $(this).attr('data-url')
                    });
                });

                collectionSchema.itemListElement = itemListElement;
                let data = JSON.stringify(collectionSchema);
                $('script.collection-page').html(data);
            }
        } else if ($('script.reviewer-page').length) {
            let reviewerSchema = JSON.parse($('script.reviewer-page').html());
            let socialLinks = $('.author-text-and-links .author-links a');
            let sameAs = [];

            socialLinks.each(function () {
                sameAs.push($(this).attr('href'));
            });

            reviewerSchema.sameAs = sameAs;
            let data = JSON.stringify(reviewerSchema);
            $('script.reviewer-page').html(data);
        } else if ($('script.faq-page').length) {
            let faqSchema = JSON.parse($('script.faq-page').html());
            let questionSet = $('.question-answer-set');
            let mainEntity = [];

            questionSet.each(function () {
                mainEntity.push({
                    "@type": "Question",
                    "name": ($(this).find('h2').length > 0) ? ($(this).find('h2').html().replace(/(<([^>]+)>)/g, "")) : ($(this).find('.collapsible-header h3').html().replace(/(<([^>]+)>)/g, "")),
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": ($(this).find('.answer').length > 0) ? ($(this).find('.answer').html().replace(/(<([^>]+)>)/g, "")) : ($(this).find('.collapsible-content').html().replace(/(<([^>]+)>)/g, ""))
                    }
                });
            });

            faqSchema.mainEntity = mainEntity;
            let data = JSON.stringify(faqSchema);
            $('script.faq-page').html(data);
        }
    });

    window.onscroll = function() {
        var currentScrollPos = $(window).scrollTop();

        if(currentScrollPos > mainHeaderHeight && window.innerWidth < 544){
            if (currentScrollPos > prevScrollPos) {//scroll down
                mainHeader.hasClass('visible')?mainHeader.removeClass('visible'):"";
                prevVisiblePos = currentScrollPos;

            } else if( prevVisiblePos - currentScrollPos > 100 && !mainHeader.hasClass('visible') ){ //scroll up
                if (embroiderySetCount.length > $('.edit-pesonalization-page .embroidery-sets .embroidery-set.completed').length) {
                    mainHeader.removeClass('visible');
                } else {
                    mainHeader.addClass('visible');
                }
            }
            prevScrollPos = currentScrollPos;
        } else if(currentScrollPos == 0 && mainHeader.hasClass('visible')){
            mainHeader.removeClass('visible');
        }

    };

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on('keyup', function (e) {

            // Delete suggestions if all input text is deleted
            if ((e.target.value.length === 0 || (e.code == 'Enter' || e.keyCode == 13)) && !(e.which == DOWN_KEY || e.which == UP_KEY)) {
                toggleSuggestionsIcon('search');
                applyModals(this);
                tearDownSuggestions();
            }

            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    $('body').on('click', function (e) {
        if (!$('.suggestions').has(e.target).length && !$(e.target).hasClass('search-field')) {
            $('.suggestions').hide();
            $('.site-search .reset-button').removeClass('d-sm-block');
            $('body').removeClass('search-suggestion-open');
        }
    });

    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
        e.preventDefault();
        $('.suggestions').hide();
        toggleSuggestionsIcon('search');
        tearDownSuggestions();
    });

    $('.site-search .reset-button').on('click', function () {
        $(this).removeClass('d-sm-block');
    });

    $('.search-field').on('focus', debounce(function () {
        if ($('.search-field').val().length === 0) {
            getDefaultSuggestions($('.search-field'));
            $('body').addClass('search-suggestion-open');
        }
    }, 300));
    $('.js-search-field').on('keypress', function(e) {
        var searchFieldVal = $('.js-search-field').val();
        if(e.code == 'Enter' && searchFieldVal == ''){
            e.preventDefault();
        };
    });

    $('.js-search-field-btn').on('click', function(e) {
        var searchFieldVal = $('.js-search-field').val();
        if(searchFieldVal == ''){
            e.preventDefault();
        };
    });

    $(document).on('focus', '.suggestions .item__link', function () {
        $(this).find('.item__img').attr('aria-hidden', 'true')
    });

    $(document).on('blur', '.suggestions .item__link', function () {
        $(this).find('.item__img').removeAttr('aria-hidden');
    });

    $(document).on('click', '.suggestions .close-button', function (e) {
        $('.suggestions').hide();
        $('body').removeClass('search-suggestion-open');
    });

    //storelocator filter apply btn event.
    $(document).on('click', '.storerocket-mobile-filters-apply-button', function () {
        $(".storerocket-dropdown-open").removeClass("storerocket-dropdown-open");
    });
};
